/**
 * List styles that allow supporting both these features at the same time:
 * 1. Left-aligned list items have their first line indentation the same as their other lines
 * 2. List markers follow the text (as opposed to staying on the left) when a list item is aligned center or right
 */
export const listStyles = `
ul, ol {
  padding-left: 0;
  counter-reset: counter;
  margin-left: 40px;
}

ul li, ol li {
  list-style: none;
  counter-increment: counter;
  position: relative;
}

ul li[style*="text-align: center"]::before, ul li[style*="text-align: right"]::before, ol li[style*="text-align: center"]::before, ol li[style*="text-align: right"]::before {
  position: relative;
  left: -0.5em;
}

ul li::before, ol li::before {
  position: absolute;
  right: calc(100% + 0.5em);
  text-wrap: nowrap;
}

ul li::before {
  content: counter(counter, disc) " ";    
}

ol li::before {
  content: counter(counter) ". ";
}

ul[style*="list-style-type: circle"] > li::before {
  content: counter(counter, circle) " ";
}

ul[style*="list-style-type: square"] > li::before {
  content: counter(counter, square) " ";
}

ol[style*="list-style-type: lower-roman"] > li::before {
  content: counter(counter, lower-roman) ". ";
}

ol[style*="list-style-type: lower-alpha"] > li::before {
  content: counter(counter, lower-alpha) ". ";
}

ol[style*="list-style-type: lower-greek"] > li::before {
  content: counter(counter, lower-greek) ". ";
}

ol[style*="list-style-type: upper-roman"] > li::before {
  content: counter(counter, upper-roman) ". ";
}

ol[style*="list-style-type: upper-alpha"] > li::before {
  content: counter(counter, upper-alpha) ". ";
}
`;
